import React from 'react'
import { Link } from "react-router-dom"

function People_Search({className,peopleData}) {
    return (
        <React.Fragment>
            <div className={`people_search ${className}`}>
                <div className="flex items-center">
                    <div className="w-12 h-12 mr-3 bg-gray-200 rounded-full overflow-hidden">
                        <img src={peopleData.profile_photo} alt="" className="w-full h-full object-cover" />
                    </div>
                    <div>
                        <a href={`https://wisemonkeys.info/${peopleData.username}`} className="color-black underline-none manpro font-medium">
                            {peopleData.full_name}
                        </a>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default People_Search
